import {Icons} from '~/common/fabric/Card/components/Icons/Icons';
import {MobileBox} from '~/common/fabric/CreateDesign/components/Background/Mobile/Contents/MobileBox';
import {EditorContainer} from '~/common/fabric/CreateDesign/components/Container/Mobile/EditorContainer';
import {useEnvelope} from '~/common/fabric/CreateDesign/components/Envelope/actions/useEnvelope';
import {useLiners} from '~/common/fabric/CreateDesign/components/Envelope/actions/useLiner';

export const EnvelopeEditorMobile = () => {
  const {envelopeIcons, onEnvelopeChange, selectedEnvelope} = useEnvelope();
  const {linerIcons, onLinerChange, selectedLiner} = useLiners();

  return (
    <EditorContainer>
      <MobileBox title="Envelope">
        <Icons
          icons={envelopeIcons}
          onClick={onEnvelopeChange}
          highlight={false}
          selectedIcon={selectedEnvelope?.icon}
          height={40}
          width={40}
          mobile
        />
      </MobileBox>
      <MobileBox title="Liner">
        <Icons
          icons={linerIcons}
          onClick={onLinerChange}
          highlight={false}
          square
          selectedIcon={selectedLiner?.icon}
          height={40}
          width={40}
          mobile
        />
      </MobileBox>
    </EditorContainer>
  );
};
